import { AutomationStatus } from '@repo/utils';
import { CaseUtil } from '@vectord/utils';
import { Triggers } from 'automations/types/automationConfig';

export const automationStatusOptions = [
  {
    label: 'Any',
    value: 'any',
  },
  ...Object.values(AutomationStatus).map((status) => ({
    label: CaseUtil.toCase('titleCase', status),
    value: status,
  })),
];

export const triggerTypeOptions = [
  {
    label: 'Any',
    value: 'any',
  },
  ...Object.values(Triggers).map((trigger) => ({
    label: CaseUtil.toCase('titleCase', trigger),
    value: trigger,
  })),
];
